import { url } from "./config";

export const loginApi = url + "/user/login/";
export const rankApi = url + "/rank/";
export const homeApi = url + "/core/home/";
export const productsApi = url + "/product/";
export const orderApi = url + "/order/";
export const settingsApi = url + "/settings/";
export const contestApi = url + "/contest/";
